export default async function checkAccountLinking({ next }) {
  const url = new URL(window.location.href)
  const messengerAccountLinkingToken = url.searchParams.get(
    'account_linking_token'
  )
  const messengerRedirectUri = url.searchParams.get('redirect_uri')
  let username = ''
  if (localStorage.getItem('token')) {
    const tokenDetails = parseJwt(localStorage.getItem('token'))
    username = tokenDetails.username
  }

  if (messengerRedirectUri && messengerAccountLinkingToken) {
    window.location.href =
      messengerRedirectUri +
      `&authorization_code=${encodeURIComponent(username)}`
  } else {
    return next()
  }
}

function parseJwt(token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}
